<template>
  <div style="background: #1f1c1f;">
    <div class="header">
      <div class="header_content">
        <div class="img">
          <img src="/img/brand/logo.png" alt="" /> Star of Harmony · Lovers' Haven
        </div>
        <div class="header-right">
          <div v-if="!hasToken" class="reg-link" @click="toLogin('/Register')">{{ $t('首页.注册') }}</div>
        </div>
      </div>
    </div>
    <div style="height: 160px;">
      <swiper class="banner_swiper" :options="bannerSwiperOption">
        <swiper-slide v-for="(v,key) in banners" :key="key">
          <van-image class="banner_img" :src="v.url" width="100%" height="160px">
            <template v-slot:loading>
              <van-loading type="circular"/>
            </template>
          </van-image>
        </swiper-slide>
      </swiper>
    </div>
    <div style="padding: 10px;">
      <van-notice-bar
        class="notice-swiper"
        color="#f3c7a2"
        background="#313131"
        scrollable
        :text="this.notice"
      >
        <template #left-icon>
          <img
            src="/img/home/notice.png"
            alt="Custom Icon"
            style="width: 15px; height: 15px; margin-right: 10px;"
          />
        </template>
      </van-notice-bar>
    </div>
    <div class="nav_box">
      <div class="x_p" @click="toLogin('/Video')">
        <img src="/img/home/icon-video.png" alt="" />
        <div class="text_c">{{ $t('首页.影片') }}</div>
      </div>
      <div class="x_p" @click="toLogin('/Choose')">
        <img src="/img/home/icon-vip.png" alt="" />
        <div class="text_c">{{ $t('首页.女团') }}</div>
      </div>
      <div class="x_p lang_p">
        <LanguageSwitcher mode="nav" />
      </div>
    </div>
    <div class="wuzii">
      <div class="put_tit">{{ $t('首页.热门城市') }}</div>
      <div class="xx_bc">
        <div class="top_link" v-for="item in cities" :key="item.id" @click="toChooseByArea(item.name)">{{ item.name }}</div>
      </div>
    </div>
    <div class="wuzii_p">
      <div class="put_tit">{{ $t('首页.经理预订') }}</div>
      <div class="xx_bc_u" @click="toLogin('/Choose')">
        {{ $t('首页.看更多') }}
      </div>
    </div>
    <div class="tu_list">
      <div class="tu_item" v-for="item in datalist" :key="item.id" @click="toDetail(item.id)">
        <div class="renzh">{{ $t('首页.身份验证') }}</div>
        <div class="info_box">
          <div class="c_id">{{ item.xuanfei_name }}</div>
          <div class="c_c">{{ $t('首页.身高') }}: {{item.hight}}cm</div>
          <div class="c_c">{{ $t('首页.胸围') }}：{{ item.bust }}</div>
          <div class="c_c">{{ $t('首页.服务城市') }} </div>
          <div class="c_b_k">
            <img src="/img/common/icon-views.png" class="sm_in">
            <span>{{item.chakan}}</span>
            <img src="/img/common/icon-love.png" class="sm_in cc">
            <span>{{item.dianzan}}</span>
          </div>
        </div>
        <img :src="`${item.img_url}`" class="sm_in_c van-image__img" style="object-fit: cover;">
      </div>
    </div>
    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
import LanguageSwitcher from '@/common/LanguageSwitcher'

export default {
  components: { LanguageSwitcher },
  data() {
    return {
      notice: '',
      translateY: -18,
      containerHeight: 0,
      hasToken: false,
      basicData: [],
      datalist: [],
      groupedData: [],
      cities: [],
      banners: [{}],
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed: 800,
        autoplay: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      },
      tagTypes: ['primary', 'success', 'danger', 'warning']
    };
  },

  methods: {
    getBasicConfig() {
      this.$http({ method: "get", url: "sys_config" }).then((res) => {
        this.basicData = res.data;
        this.getNotice(this.basicData);
        this.getBanner(this.basicData);
      });
    },

    // ★ 点击州名跳转到 Choose 页面并传地区参数
    toChooseByArea(areaName) {
      this.$router.push({ path: '/Choose', query: { area: areaName } });
    },

    getBanner(data) {
      this.banners = data.banners;
    },

    toLogin(str) {
      this.$router.push({ path: str });
    },

    getNotice(data) {
      if (!data.notice) {
        this.notice = ''
        return
      }
      if (typeof data.notice === 'object') {
        const locale = this.$i18n.locale
        const short = locale.split('-')[0]
        this.notice = data.notice[locale] || data.notice[short] || data.notice['zh-cn'] || data.notice.zh || data.notice.en || ''
        return
      }
      if (typeof data.notice === 'string') {
        const parts = data.notice.split('|')
        if (parts.length > 1) {
          const locale = this.$i18n.locale
          const langMap = {
            'zh-cn': 0, zh: 0,
            'en-us': 1, en: 1,
            'ja-jp': 2, ja: 2, jp: 2,
          }
          const idx = langMap[locale] ?? langMap[locale.split('-')[0]] ?? 1
          this.notice = parts[idx] || parts[0]
        } else {
          this.notice = data.notice
        }
      }
    },

    startAnimation() {
      const interval = setInterval(() => {
        this.translateY -= 18;
        if (this.translateY <= -this.containerHeight) {
          this.translateY = 0;
        }
      }, 1000);
      this.$once("hook:beforeDestroy", () => { clearInterval(interval); });
    },

    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },

    checkToken() {
      const token = localStorage.getItem("token");
      this.hasToken = !!token;
    },

    getCityList() {
      this.$http({
        method: "get",
        url: "address_list",
      }).then((res) => {
        const list = [];
        const rows = Array.isArray(res.data) ? res.data : [];
        rows.forEach(item => {
          if (Array.isArray(item)) {
            item.forEach(city => {
              if (city && city.name) list.push(city);
            });
          } else if (item && item.name) {
            list.push(item);
          }
        });
        this.cities = list;
      });
    },

    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: 1, page: 1 },
      }).then((res) => {
        const lang = this.$i18n.locale === 'zh-cn' ? 'zh' : 'en';
        this.datalist = res.data;
        this.datalist.forEach(item => {
          if (item.flag) {
            const parts = item.flag.split('|');
            lang == 'zh' ? item.flag = parts[0]
              : lang == 'en' ? item.flag = parts[1]
              : lang == 'ja' ? item.flag = parts[2]
              : item.flag = parts[3];
            item.flagArray = item.flag ? item.flag.split('，') : [];
          } else {
            item.flagArray = [];
          }
        });
        const chunkSize = 2;
        this.groupedData = this.datalist.reduce((acc, item, index) => {
          if (index % chunkSize === 0) acc.push([]);
          acc[Math.floor(index / chunkSize)].push(item);
          return acc;
        }, []);
      });
    },
  },

  mounted() {
    if (this.$refs.scrollContainer) {
      this.containerHeight = this.$refs.scrollContainer.clientHeight;
      this.startAnimation();
    }
  },

  created() {
    this.checkToken();
    this.getBasicConfig();
    this.getCityList();
    this.getxuanfeilist();
  },
};
</script>

<style lang="less" scoped>
.tu_list {
  .tu_item {
    margin: 26px 20px 16px;
    border-radius: 16px;
    padding: 30px 40px 30px 26px;
    background: linear-gradient(120deg, #212121, #313131);
    border: 1px solid #766350;
    display: flex;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    .renzh {
      position: absolute;
      right: -58px;
      top: 24px;
      font-size: 24px;
      padding: 2px 48px;
      font-style: normal;
      white-space: nowrap;
      transform: rotate(45deg);
      background: linear-gradient(90deg, #efcba7, #dcab76);
      color: #000000;
    }
    .sm_in_c {
      width: 186px;
      height: 186px;
      border-radius: 50%;
    }
    .info_box {
      .c_id {
        width: 200px;
        text-align: center;
        background: linear-gradient(90deg, #efcba7, #dcab76);
        color: #8d5825;
        border-radius: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .c_c {
        color: #ddd;
        font-size: 26px;
        padding-top: 10px;
      }
      .c_b_k {
        display: flex;
        align-items: center;
        color: #666;
        font-size: 22px;
        padding-top: 16px;
        .sm_in {
          width: 30px;
          height: 30px;
          &.cc { margin-left: 16px; }
        }
      }
    }
  }
}
.nav_box {
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: 1px solid #766350;
  margin: 10px 20px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg, #212121, #313131);
  .x_p {
    text-align: center;
    color: #e6b98a;
    flex: 1;
    img { height: 76px; }
  }
  .lang_p {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.put_tit {
  font-weight: bold;
  color: #e6b98a;
  font-size: 28px;
  padding-left: 16px;
  position: relative;
  &::before {
    content: "";
    display: block;
    position: absolute;
    width: 8px;
    height: 30px;
    background-color: #e6b98a;
    left: 0;
    top: 6px;
  }
}
.wuzii {
  margin: 26px 20px 16px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg, #212121, #313131);
  border: 1px solid #766350;
  .xx_bc {
    display: flex;
    flex-wrap: wrap;
    font-size: 26px;
    color: #ccc;
    padding-top: 10px;
    justify-content: space-between;
    .top_link { padding: 20px 20px; cursor: pointer; }
    .top_link:hover { color: #e6b98a; }
  }
}
.wuzii_p {
  margin: 26px 20px 16px;
  background: linear-gradient(120deg, #212121, #313131);
  display: flex;
  padding: 20px 20px;
  justify-content: space-between;
  .xx_bc_u { color: #ccc; }
}
.header {
  height: 13vw;
}
.header_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 40px;
  color: #fff;
  .img {
    height: 80px;
    display: inline-flex;
    align-items: center;
    img { width: auto; height: 100%; margin-right: 10px; }
  }
  .header-right {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .reg-link {
    color: #e6b98a;
  }
}
.notice-swiper {
  height: 11vw;
  font-size: 4vw;
  border-radius: 16px;
  border: 1px solid #766350;
}
</style>